import { ChartInfoKind } from '@frontend/chart/types';

import { ChartCardInfoIcon } from './chart-card-info-icon.component';
import { resolveChartInfoKind } from './chart-key-to-info-kind';

export interface ChartCardTitleProps {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    chartKey?: string;
    infoKind?: ChartInfoKind;
    compact?: boolean;
    titleClassName?: string;
    subtitleClassName?: string;
}

export const ChartCardTitle = ({ title, subtitle, chartKey, infoKind, compact = false, titleClassName = '', subtitleClassName = '' }: ChartCardTitleProps) => {
    const resolvedInfoKind = resolveChartInfoKind(chartKey, infoKind);

    if (!resolvedInfoKind) {
        return (
            <div className='min-w-0'>
                <div className={titleClassName}>{title}</div>
                {subtitle ? <div className={subtitleClassName}>{subtitle}</div> : null}
            </div>
        );
    }

    return (
        <div className='min-w-0'>
            <div className='flex items-center gap-2'>
                <div className={`min-w-0 flex-1 ${titleClassName}`.trim()}>{title}</div>
                <ChartCardInfoIcon
                    infoKind={resolvedInfoKind}
                    compact={compact}
                />
            </div>
            {subtitle ? <div className={subtitleClassName}>{subtitle}</div> : null}
        </div>
    );
};
